import { api } from '@/api';
import { RootState } from '@/store/index';
import { Setting } from '@/types/Setting';
import { ActionContext, Module } from 'vuex';

export type SettingsState = {
    settings: Setting[];
};

export const settings: Module<SettingsState, RootState> = {
    state: {
        settings: [],
    },
    mutations: {
        setSettings(state: SettingsState, settings: Pick<Setting, 'key' | 'value'>[]) {
            state.settings = settings.map((setting) => ({
                key: setting.key,
                value: setting.value,
            }));
        },
    },
    getters: {
        settings: (state) => state.settings,
        settingByKey: (state) => (key: string) => state.settings.find((setting) => setting.key === key),
    },
    actions: {
        async fetchSettings(context: ActionContext<SettingsState, RootState>) {
            const response = await api.get('/settings');

            if (!response || !response.data) {
                throw new Error('Could not load settings');
            }

            context.commit('setSettings', response.data.data);
        },
    },
};
